import DropDown from "./components/Dropdown.vue";
import MyDialog from "./pages/Dashboard/Components/MyDialog";
import { ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
import {
  CollapseTransition,
  SlideYDownTransition,
  FadeTransition,
  ZoomCenterTransition
} from "../node_modules/vue2-transitions";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("my-dialog", MyDialog);
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);
    Vue.component("CollapseTransition", CollapseTransition);
    Vue.component("SlideYDownTransition", SlideYDownTransition);
    Vue.component("FadeTransition", FadeTransition);
    Vue.component("ZoomCenterTransition", ZoomCenterTransition);
    Vue.component('v-select', vSelect);
  }
};

export default GlobalComponents;
